import request from '../utils/request';

export const productApi = {
  // 获取商品列表
  getProductList: (params) => {
    return request({
      url: '/product/list',
      method: 'get',
      params: {
        // 支持的搜索参数
        name: params.name,
        category: params.category,
        status: params.status,
        auditStatus: params.auditStatus,
        page: params.page,
        pageSize: params.pageSize
      }
    });
  },

  // 创建商品
  createProduct: (data) => {
    return request({
      url: '/product/create',
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data
    });
  },

  // 更新商品
  updateProduct: (id, data) => {
    return request({
      url: `/product/update/${id}`,
      method: 'put',
      headers: { 'Content-Type': 'multipart/form-data' },
      data
    });
  },

  // 删除商品
  deleteProduct: (id) => {
    return request({
      url: `/product/delete/${id}`,
      method: 'delete'
    });
  },

  // 切换商品状态
  toggleProductStatus: (id) => {
    return request({
      url: `/product/toggle-status/${id}`,
      method: 'patch'
    });
  },

  // 获取分类列表
  getCategoryList: (params) => {
    return request({
      url: '/product/category/list',
      method: 'get',
      params: {
        name: params.name,
        code: params.code,
        page: params.page,
        pageSize: params.pageSize
      }
    });
  },

  // 创建分类
  createCategory: (data) => {
    return request({
      url: '/product/category/create',
      method: 'post',
      data
    });
  },

  // 更新分类
  updateCategory: (id, data) => {
    return request({
      url: `/product/category/update/${id}`,
      method: 'put',
      data
    });
  },

  // 删除分类
  deleteCategory: (id) => {
    return request({
      url: `/product/category/delete/${id}`,
      method: 'delete'
    });
  },

  // 商品审核
  auditProduct: (id, status) => {
    return request({
      url: `/product/audit/${id}`,
      method: 'patch',
      data: { status }
    });
  }
}; 